import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography, Grid, Checkbox, Tooltip } from '@mui/material'
import { useIntl } from 'react-intl'

import { TextInput, ThemeButton, SelectInput, AutocompleteInput } from '../../../../ui'
import { EDIT_FORM_CONFIG } from './new-manager.constants'
import { useManagersCalls } from '../../hooks/managers-calls.hook'
import { addManager } from '../../slices'

export const NewManager = ({ close }) => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const managers = useSelector((state) => state.managers.data)
  const dispatch = useDispatch()
  const { getComboByRol } = useManagersCalls()
  const [formState, setFormState] = useState({})
  const [fethecdPerms, setFetchedPerms] = useState([])
  const [perms, setPerms] = useState([])
  const [havePerms, setHavePerms] = useState(true)

  const handleChangeForm = (e) => {
    const name = e?.target?.name || e?.name
    let value =
      e?.target !== undefined
        ? e.target.value
        : Array.isArray(e?.value)
          ? e.value.map((v) => v.key || v)
          : e?.value

    if (name === 'cc_aa' && Array.isArray(value)) {
      value = value.map((value) => parseInt(value, 10))
    }

    if (name === 'rol') setPerms([])
    setFormState((prev) => ({ ...prev, [name]: value }))
  }

  const handleNewUser = (e) => {
    e.preventDefault()
    dispatch(addManager({ ...formState, extra_permission: perms }, managers))
    close()
  }

  const handleTogglePermission = (e) => {
    const supportArray = perms
    const index = supportArray.indexOf(e.target.name)
    if (index !== -1) {
      supportArray.splice(index, 1)
    } else {
      supportArray.push(e.target.name)
    }
    setPerms([...supportArray])
  }

  useEffect(() => {
    if (formState.rol) {
      getComboByRol(formState.rol).then((response) => {
        if (response.data.length === 0) {
          setHavePerms(false)
          setFetchedPerms(response.data)
        } else {
          setHavePerms(true)
          setFetchedPerms(response.data)
        }
      })
    }
  }, [formState.rol]) // eslint-disable-line react-hooks/exhaustive-deps

  const selectedRole = combos.roles?.data?.find((r) => r.key === formState.rol)
  const isOrganismoIP = selectedRole?.value?.toLowerCase().includes('organismo ip')
  const inputProps = { formState, combos, intl, onChange: handleChangeForm }
  return (
    <Box sx={{ pl: 4, pr: 4, pb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3" color="primary">
          {intl.formatMessage({ id: 'pages.managers.dialogs.new.title' })}
        </Typography>
      </Box>
      <form onSubmit={handleNewUser}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).NOMBRE} />
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).APELLIDOS} />
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <Box
              sx={{
                '& .MuiTypography-subtitle1': {
                  marginBottom: '0px !important',
                  fontFamily: 'FSEmeric-Medium',
                },
                '& .MuiFormControl-root': {
                  marginTop: '0px !important',
                },
                '& .MuiOutlinedInput-root': {
                  minHeight: '48px',
                },
              }}
            >
              <SelectInput {...EDIT_FORM_CONFIG(inputProps).ROL} />
            </Box>
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).TELEFONO} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).USERNAME} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).CORREO_ELECTRONICO} />
          </Grid>
          {isOrganismoIP && (
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <Box
                sx={{
                  '& .MuiTypography-subtitle1': {
                    marginBottom: '0px !important',
                    fontFamily: 'FSEmeric-Medium',
                  },
                  '& .MuiFormControl-root': {
                    marginTop: '0px !important',
                  },
                  '& .MuiOutlinedInput-root': {
                    minHeight: '48px',
                  },
                }}
              >
                <AutocompleteInput {...EDIT_FORM_CONFIG(inputProps).CCAA} />
              </Box>
            </Grid>
          )}
        </Grid>
        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="h6" color="primary">
            Permisos
          </Typography>
        </Box>
        <Grid container spacing={1}>
          {fethecdPerms.length > 0 ? (
            fethecdPerms?.map((perm) => {
              return (
                <Grid key={perm.key} size={{ xs: 6, sm: 4, md: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={perms.some((pm) => pm === perm.key)}
                      name={perm.key}
                      onChange={(e) => handleTogglePermission(e)}
                    />
                    <Tooltip
                      placement="top"
                      arrow
                      title={<Typography variant="body2">{perm.description}</Typography>}
                    >
                      <Typography>{perm.value}</Typography>
                    </Tooltip>
                  </Box>
                </Grid>
              )
            })
          ) : havePerms ? (
            <Box sx={{ mt: 2, ml: 1 }}>
              <Typography variant="body3">Escoge un rol para poder editar los permisos</Typography>
            </Box>
          ) : (
            <Box>
              <Typography variant="body3">Este rol no tiene permisos extra</Typography>
            </Box>
          )}
        </Grid>
        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'space-between' }}>
          <ThemeButton onClick={close} variant="outlined" labelM="lg">
            {intl.formatMessage({ id: 'global.cancel' })}
          </ThemeButton>
          <ThemeButton color="primary" type="submit" labelM="lg">
            {intl.formatMessage({ id: 'global.accept' })}
          </ThemeButton>
        </Box>
      </form>
    </Box>
  )
}
